export default __webpack_public_path__ + "static/media/bodyandspiritwrack1.1d904d31.png";